export type ErrorResponse = {
  id: number;
  message: string;
  timestamp: string;
};
